import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import './App.css';
import RNANavbar from "./components/Navbar";
import { Home } from "./pages/Home";
import Footer from "./components/Footer";
import DisclaimerModal from "./components/DisclaimerModal"; 
import { Contact } from "./pages/Contact";
import { Testimonials } from "./pages/Testimonials";
import { OurStory } from "./pages/OurStory";
import { OurTeam } from "./pages/OurTeam";
import { WhyChooseUs } from "./pages/WhyChooseUs ";
import ScrollToTop from "./components/ScrollToTop";
import { DisputeResolution } from "./pages/DisputeResolution";
import { ADRServices } from "./pages/ArbitrationMediation";
import { RealEstateLaw } from "./pages/RealEsatate";
import { CorporateCommercialLaw } from "./pages/CorporateLaw";
import { BankingSecuritization } from "./pages/Banking";
import { TaxationLaw } from "./pages/Taxition";
import { IntellectualPropertyLaw } from "./pages/IntellectualProprty";
import { BlogPage } from "./pages/Blog";
import { ToastContainer } from "react-toastify"; // FIXED: Changed from "react-bootstrap"
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <Router>
      <DisclaimerModal />
      <ScrollToTop/>
      <div className="d-flex flex-column min-vh-100">
        <RNANavbar />
        <main className="flex-grow-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact/>} />
            <Route path="/testimonials" element={<Testimonials/>}/>
            <Route path="/about-us" element={<OurStory/>}/>
            <Route path="/ourteam" element={<OurTeam/>}/>
            <Route path="/whychooseus" element={<WhyChooseUs/>}/>
            <Route path="/DisputeResolution" element={<DisputeResolution/>}/>
            <Route path="/ArbitrationMediation" element={<ADRServices/>}/>
            <Route path="/RealEstateLaw" element={<RealEstateLaw/>}/>
            <Route path="/CorporateCommercialLaw" element={<CorporateCommercialLaw/>}/>
            <Route path="/BankingSecuritization" element={<BankingSecuritization/>}/>
            <Route path="/TaxationLaw" element={<TaxationLaw/>}/>
            <Route path="/IntellectualPropertyLaw" element={<IntellectualPropertyLaw/>}/>
            <Route path="/BlogPage" element={<BlogPage/>}/>
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
        <ToastContainer position="bottom-right" />
      </div>
    </Router>
  );
}

export default App;